export default "__VITE_ASSET__Bf9KgWF6__"